import { render } from "./DashboardCharts.vue?vue&type=template&id=c625f584&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"

import "./DashboardCharts.vue?vue&type=style&index=0&id=c625f584&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c625f584"

export default script